import Cookies from 'js-cookie';

import {
	AUTH_DEMO_INFO,
	AUTH_DEMO_TOKEN_EXPIRY,
	AUTH_TOKEN_EXPIRY,
	AUTH_TOKEN_NAME,
	IS_AUTHORIZED_COOKIE_NAME,
	QUERY_AUTH_PARAM_NAME,
	QUERY_TOKEN_PARAM_NAME,
} from '~constants/token';
import type { TAuthDemoUserInfo } from '~services/api/auth/types';
import { getHost } from '~utils/host';

class ClientTokenHandler {
	private queryToken: string | undefined;
	private cookieToken: string | undefined;
	private demoData: TAuthDemoUserInfo | undefined;
	constructor() {
		this.init();
	}
	init = () => {
		if (typeof window === 'undefined') return;
		const query = new URLSearchParams(window.location.search);
		this.queryToken = (query.get(QUERY_AUTH_PARAM_NAME) ||
			query.get(QUERY_TOKEN_PARAM_NAME)) as string;
		this.cookieToken = Cookies.get(AUTH_TOKEN_NAME);
		this.demoData = JSON.parse(
			Cookies.get(AUTH_DEMO_INFO) ?? '{}'
		) as TAuthDemoUserInfo;
		if (!!this.queryToken) {
			this.saveToken(this.queryToken);
			return (this.queryToken = undefined);
		}
		if (!!this.cookieToken) {
			return this.saveToken(this.cookieToken);
		}
	};
	getInfo = () => {
		if (this.queryToken) {
			return { token: this.queryToken, type: 'query' };
		}
		if (this.cookieToken) {
			return { token: this.cookieToken };
		}
		if (this.demoData?.token) {
			return {
				token: this.demoData.token,
				userId: this.demoData.userId,
				type: 'demo',
			};
		}
		return { token: undefined };
	};
	saveDemoCredentials = (data: TAuthDemoUserInfo) => {
		Cookies.set(AUTH_DEMO_INFO, JSON.stringify(data), {
			expires: this.expiryDateDemo,
			domain: getHost(),
		});
		this.demoData = data;
		this.queryToken = undefined;
		this.cookieToken = undefined;
	};
	makeDemoCredentialsMain = () => {
		this.cookieToken = this.demoData?.token ?? '';
		this.saveToken(this.cookieToken);
		this.queryToken = undefined;
		this.clearToken('demo');
	};
	clearToken = (type: 'demo' | 'main' | 'query') => {
		if (type === 'demo') {
			Cookies.set(AUTH_DEMO_INFO, '', {
				expires: -1,
				domain: getHost(),
			});
		}
		if (type === 'main') {
			Cookies.set(AUTH_TOKEN_NAME, '', {
				expires: -1,
				domain: getHost(),
				sameSite: 'none',
				secure: true,
			});
			Cookies.set(IS_AUTHORIZED_COOKIE_NAME, '', {
				expires: -1,
				domain: getHost(),
			});
		}
		if (type === 'query') {
			this.queryToken = undefined;
		}
	};
	saveToken(token: string) {
		Cookies.set(AUTH_TOKEN_NAME, token, {
			expires: this.expiryDate,
			domain: getHost(),
			sameSite: 'none',
			secure: true,
		});
		this.cookieToken = token;
	}
	private get expiryDate() {
		const date = new Date();
		date.setTime(date.getTime() + AUTH_TOKEN_EXPIRY);
		return date;
	}
	private get expiryDateDemo() {
		const date = new Date();
		date.setTime(date.getTime() + AUTH_DEMO_TOKEN_EXPIRY);
		return date;
	}
}

export const TokenManager = new ClientTokenHandler();
